import { SubscriptionLog } from "../../../../../../types"
import EngagementsBadges from "./engagements-badges"
import EngagementsEvents from "./engagements-events"
import EngagementsStatus from "./engagements-status"

type Props = {
  info: SubscriptionLog
  onClick: (id: string) => void
}

const EngagementsCell = ({ info, onClick }: Props) => {
  const { email, active, source, id, deleted, first_name, last_name } = info

  const name =
    first_name || last_name ? `${first_name} ${last_name}` : "Unnamed"

  return (
    <td className="whitespace-nowrap py-4 pl-2 pr-3 cursor-pointer" colSpan={2}>
      <div className="flex items-center">
        <div
          className="font-bold mr-2 hover:border-b border-neutral-500 leading-none"
          onClick={() => onClick(id)}
        >
          {name}
        </div>

        <EngagementsStatus deleted={deleted === "1"} active={active === "1"} />
      </div>
      <div className="text-neutral-400 text-sm">{email}</div>
      <div className="flex items-center mt-1">
        <EngagementsBadges source={source} />
        <EngagementsEvents id={id} />
      </div>
    </td>
  )
}

export default EngagementsCell
